import { isTest } from '~/utils/env';
import { loadJS } from '~/utils/scripts';

declare const grecaptcha: {
    ready: (callback: () => void) => void;
    execute: (key: string, options: { action: string }) => Promise<string>;
};

export class RecaptchaLoadError extends Error { }

/** URL du SDK reCAPTCHA v3 */
export const recaptchaURL = () =>
    `https://www.google.com/recaptcha/api.js?render=${globalThis.VITE_RECAPTCHA_KEY ?? ''}`;

/** Charge la librairie reCAPTCHA, sauf en test. */
export async function initRecaptcha() {
    if (isTest()) return;

    try {
        await loadJS(recaptchaURL());
        if (typeof grecaptcha === 'undefined') {
            console.error(new RecaptchaLoadError('Impossible de charger reCAPTCHA'));
        }
    } catch {
        console.error(new RecaptchaLoadError('Impossible de charger reCAPTCHA'));
    }
}

/** Exécute reCAPTCHA côté client et retourne le jeton à envoyer au backend. */
export function ensureUserIsNotARobot(action: string = 'default'): Promise<string> {
    if (isTest()) return Promise.resolve('');

    return new Promise((resolve) => {
        if (typeof grecaptcha === 'undefined') {
            console.error(new RecaptchaLoadError('reCAPTCHA non disponible'));
            resolve('');
            return;
        }

        grecaptcha.ready(() => {
            grecaptcha
                .execute(globalThis.VITE_RECAPTCHA_KEY ?? '', { action })
                .then(resolve)
                .catch(() => resolve(''));
        });
    });
}
